





































import { Component, Vue, Prop } from "vue-property-decorator";
import utils from "basis/utils";
import { KYCShowsStatus } from "basis/utils/kyc";
import { KYCProfile } from "@foxone/api/src/models/account";

@Component
class KYCStatusSection extends Vue {
  @Prop() profile!: KYCProfile;

  get meta() {
    const {
      name = "",
      kyc_status: status,
      kyc_error: error,
      kyc_error_message: message
    } = this.profile;
    const kycStatusMeta = utils.kyc.getKYCStatusMeta(status);
    const kycStatus = kycStatusMeta && kycStatusMeta.status;
    const showName = Array.from(name)
      .map((c, i) => (i > 0 ? "*" : c))
      .join("");
    return {
      showName,
      error,
      message,
      isNotYet: kycStatus === KYCShowsStatus.NOTYET,
      isProcessing: kycStatus === KYCShowsStatus.PROCESSING,
      isReject: kycStatus === KYCShowsStatus.REJECTED,
      isApproved: kycStatus === KYCShowsStatus.APPROVED
    };
  }
}
export default KYCStatusSection;
